var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartTile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 128,
    viewBox: "0 0 170 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 98.6154,
    height: 98.6154,
    rx: 16,
    transform: "matrix(0.861934 0.50702 -0.861934 0.50702 85 28)",
    fill: "#29B2EA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 98.6154,
    height: 98.6154,
    rx: 16,
    transform: "matrix(0.861934 0.50702 -0.861934 0.50702 85 20)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_f_1_6152)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 85,
    cy: 80,
    rx: 30,
    ry: 10,
    fill: "#29B1EA"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.1083 28.495L57.93 24.95L58.7367 21.7167L71.225 24.8383L84.5583 13.1717L98.05 16.545L110.783 8.58667L112.55 11.4133L98.6167 20.1217L85.4417 16.8283L72.1083 28.495Z",
    fill: "url(#paint0_linear_1_6152)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.333 31.6667V68.3333H105V31.6667C105 30.7467 105.747 30 106.667 30H116.667C117.587 30 118.333 30.7467 118.333 31.6667Z",
    fill: "#50E6FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105 43.3334V68.3334H91.6667V43.3334H105Z",
    fill: "#35C1F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6667 40V68.3334H78.3333V40C78.3333 39.08 79.08 38.3334 80 38.3334H90C90.92 38.3334 91.6667 39.08 91.6667 40Z",
    fill: "#199BE2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3333 51.6666V68.3333H65V51.6666H78.3333Z",
    fill: "#0078D4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M65 46.6667V68.3333H51.6667V46.6667C51.6667 45.7467 52.4133 45 53.3333 45H63.3333C64.2533 45 65 45.7467 65 46.6667Z",
    fill: "#0D62AB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M111.667 13.3333C113.508 13.3333 115 11.8409 115 9.99996C115 8.15901 113.508 6.66663 111.667 6.66663C109.826 6.66663 108.333 8.15901 108.333 9.99996C108.333 11.8409 109.826 13.3333 111.667 13.3333Z",
    fill: "url(#paint1_linear_1_6152)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M98.3333 21.6667C100.174 21.6667 101.667 20.1743 101.667 18.3333C101.667 16.4924 100.174 15 98.3333 15C96.4924 15 95 16.4924 95 18.3333C95 20.1743 96.4924 21.6667 98.3333 21.6667Z",
    fill: "url(#paint2_linear_1_6152)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85 18.3333C86.841 18.3333 88.3333 16.8409 88.3333 15C88.3333 13.159 86.841 11.6666 85 11.6666C83.1591 11.6666 81.6667 13.159 81.6667 15C81.6667 16.8409 83.1591 18.3333 85 18.3333Z",
    fill: "url(#paint3_linear_1_6152)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6667 30C73.5076 30 75 28.5077 75 26.6667C75 24.8258 73.5076 23.3334 71.6667 23.3334C69.8257 23.3334 68.3333 24.8258 68.3333 26.6667C68.3333 28.5077 69.8257 30 71.6667 30Z",
    fill: "url(#paint4_linear_1_6152)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3333 26.6667C60.1743 26.6667 61.6667 25.1743 61.6667 23.3333C61.6667 21.4924 60.1743 20 58.3333 20C56.4924 20 55 21.4924 55 23.3333C55 25.1743 56.4924 26.6667 58.3333 26.6667Z",
    fill: "url(#paint5_linear_1_6152)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_6152",
    x: 31,
    y: 46,
    width: 108,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_1_6152"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_6152",
    x1: 57.93,
    y1: 18.54,
    x2: 112.55,
    y2: 18.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#912FBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9332BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_6152",
    x1: 108.333,
    y1: 9.99996,
    x2: 115,
    y2: 9.99996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C965EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C767E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_6152",
    x1: 95,
    y1: 18.3333,
    x2: 101.667,
    y2: 18.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C965EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C767E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_6152",
    x1: 81.6667,
    y1: 15,
    x2: 88.3333,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C965EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C767E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_6152",
    x1: 68.3333,
    y1: 26.6667,
    x2: 75,
    y2: 26.6667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C965EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C767E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_6152",
    x1: 55,
    y1: 23.3333,
    x2: 61.6667,
    y2: 23.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C965EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C767E5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartTile);
export default __webpack_public_path__ + "static/media/chartTile.dd6675f66c4db2fbbf104981c8267bcf.svg";
export { ForwardRef as ReactComponent };